/**
 * Card header for NON-tabbed admin forms. Renders a single, non-interactive
 * MUI Tab so the section anchor is pixel-identical to the real tab row on
 * tabbed forms (same font family / size / weight and teal active colour, with
 * the standard grey divider). The active indicator is hidden - the divider
 * alone separates header from fields.
 *
 * Shares its styling with the tabbed header via `adminFormChrome.styles.ts`,
 * so the teal heading colour is defined in exactly one place.
 */
import React from 'react'
import { Tab, Tabs } from '@mui/material'
import { formHeaderTabsSx } from './adminFormChrome.styles'

const AdminFormSectionHeader: React.FC<{ title: string }> = ({ title }) => (
  <Tabs
    value={0}
    sx={{
      ...formHeaderTabsSx,
      minHeight: 64,
      borderBottom: 1,
      borderColor: 'divider',
      '& .MuiTabs-indicator': { display: 'none' },
    }}
  >
    <Tab disableRipple label={title} sx={{ cursor: 'default' }} />
  </Tabs>
)

export default AdminFormSectionHeader
